module.exports = __webpack_public_path__ + "static/media/avadefault.f1741fc3.svg";